import $ from 'jquery'
import { prepareChessboard, loadNextConfiguration, showMagnus } from "../../utils";
import ChessBoard from '../../components/chessBoard';
import { CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO } from '../../utils/constants';

/**
 * @name lesson18Activity1
 * @function
 * @param { config }
 * @description: Number of squares
 */

export function lesson18Activity1(config) {
  let position = config.position;

  let afterLoad = function () {
    prepareChessboard(config);
    $('#chessBoard').addClass('custom-background-image-5x5');
    $('.row-5277c:nth-child(-n+3)').css('display', 'none');
    $('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display', 'none');
    let body = `
            <div class='activity-1-lesson-18'>
                <div class='first-column'>
                    <h4 class='input-rows' id='tbl-cell-0'></h4>
                </div>
                <div class='first-column'>
                    <h4 class='input-rows' id='tbl-cell-1'></h4>
                </div>
                <div class='first-column'>
                    <h4 class='input-rows' id='tbl-cell-2'></h4>
                </div>
                <div class='first-column'>
                    <h4 class='input-rows' id='tbl-cell-3'></h4>
                </div>
                <div class='first-column'>
                    <h4 class='input-rows' id='tbl-cell-4'></h4>
                </div>
            </div>`;
    $('.left-box-content').html(body);
    let count = 0;
    let timer = setInterval(function () {
      if (count > 5) {
        clearInterval(timer);
      } else {
        $(`#tbl-cell-${count}`).html((count + 1));
        count++;
      }
    }, 500)
    let timerTwo = setTimeout(function () {
      let count = 0;
      let timer = setInterval(function () {
        if (count > 5) {
          clearInterval(timer);
        } else {
          $(`#tbl-cell-${count}`).html((count + 1) + ' x ' + (count + 1) + ' =   ');
          count++;
        }
      }, 500)
    }, 2500)
    let timerThree = setTimeout(function () {
      let count = 0;
      let timer = setInterval(function () {
        if (count > 5) {
          clearInterval(timer);
        }
        if (count === 0) {
          $(`#tbl-cell-${count}`).html((count + 1) + ' x ' + (count + 1) + ' =  <input id="custom-input-' + (count + 1) + '" class="custom-input" type="text" value="1"> <img src="img/yellow-arrow.svg" id="yellow-arrow"/>');
          $('.square-e5').html('<h4 class="header-4">' + (count + 1) + '</h4>');
          count++;
        } else {
          $(`#tbl-cell-${count}`).html((count + 1) + ' x ' + (count + 1) + ' =   <input id="custom-input-' + (count + 1) + '" class="custom-input" type="text" placeholder="?">');
          count++;
        }
      }, 200)
    }, 5000)
    let timerFour = setTimeout(function () {
      $(function () {
        $('#custom-input-2').prop('disabled', true);
        $('#custom-input-3').prop('disabled', true);
        $('#custom-input-4').prop('disabled', true);
        $('#custom-input-5').prop('disabled', true);
      })
      setTimeout(function () {
        $('#custom-input-2').prop('disabled', false);
        $('#custom-input-3').prop('disabled', false);
        $('#custom-input-4').prop('disabled', false);
        $('#custom-input-5').prop('disabled', false);
      }, 22000)
      var firstInput, secondInput, thirdInput, fourthInput, data = '';
      $(function () {
        $('#custom-input-2').keyup(function () {
          firstInput = this.value;
          if (firstInput) {
            if (firstInput === '4') {
              $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
              $('#custom-input-2').prop('disabled', true);
              $('.square-d4').html('<h4 class="header-4">' + firstInput + '</h4>');
            }
            else {
              $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
              data = 'OOPS!<br/>Try again!!'
              showMagnusMessage(data);
              setTimeout(function () {
                $('#custom-input-2').val('')
              }, 1500)
            }
          }
        })
      })
      $(function () {
        $('#custom-input-3').keyup(function () {
          secondInput = this.value;
          if (secondInput) {
            if (secondInput === '9') {
              $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
              $('#custom-input-3').prop('disabled', true);
              $('.square-c3').html('<h4 class="header-4">' + secondInput + '</h4>');
            }
            else {
              $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
              data = 'OOPS!<br/>Try again!!'
              showMagnusMessage(data);
              setTimeout(function () {
                $('#custom-input-3').val('')
              }, 1500)
            }
          }
        })
      })
      $(function () {
        $('#custom-input-4').keyup(function () {
          thirdInput = this.value;
          var ValueOfFourthSquare = setInterval(valueFourthSquare, 2000)
          function valueFourthSquare() {
            clearInterval(ValueOfFourthSquare);
            if (thirdInput) {
              if (thirdInput === '16') {
                $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
                $('#custom-input-4').prop('disabled', true);
                $('.square-b2').html('<h4 class="header-4">' + thirdInput + '</h4>');
              }
              else {
                $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
                data = 'OOPS!<br/>Try again!!'
                showMagnusMessage(data);
                setTimeout(function () {
                  $('#custom-input-4').val('')
                }, 1500)
              }
            }
          }
        })
      })
      $(function () {
        $('#custom-input-5').keyup(function () {
          fourthInput = this.value;
          var ValueOfFifthSquare = setInterval(valueFifthSquare, 2000)
          function valueFifthSquare() {
            clearInterval(ValueOfFifthSquare);
            if (fourthInput) {
              if (fourthInput === '25') {
                $('#custom-input-5').prop('disabled', true);
                $('.square-a1').html('<h4 class="header-4">' + fourthInput + '</h4>');
              }
              else {
                $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
                data = 'OOPS!<br/>Try again!!'
                showMagnusMessage(data);
                setTimeout(function () {
                  $('#custom-input-5').val('')
                }, 1500)
              }
            }
          }
        })
      })
      function showMagnusMessage(data) {
        showMagnus({
          data: data,
          position: 'right',
          styleClass: 'md'
        })
        setTimeout(function () {
          $('.speech-bubble').remove();
        }, 3000)
      }
      var timer = setInterval(function () {
        if (firstInput === '4' && secondInput === '9' && thirdInput === '16' && fourthInput === '25') {
          clearInterval(timer);
          data = 'Well done John!';
          showMagnusMessage(data);
          setTimeout(function () {
            $('.header-4').remove();
            $('.activity-1-lesson-18').remove();
          }, 3000)
          loadNextConfiguration(4000, config.next, true);
        }
      })
    }, 7500)
    $('.back-btn-container #previous, .next-btn-container #next').on('click', function () {
      clearTimeout(timer); clearTimeout(timerTwo);
      clearTimeout(timerThree); clearTimeout(timerFour);
      $('.speech-bubble').remove();
      $('.activity-1-lesson-18').remove();
    })
  }

  const chessConfig = {
    config: {
      position: position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
 * @name lesson18Activity2
 * @function
 * @param { config }
 * @description: Animate moves
 */

export function lesson18Activity2(config) {
  let position = config.position,
    next = config.next,
    from = config.from,
    to = config.to;

  let afterLoad = function () {
    prepareChessboard(config);
    let count = 0;
    $('.back-btn-container #previous').on('click', function () {
      clearInterval(timer);
    })

    let timer = setInterval(function () {
      ChessBoard.board.move(`${from[count]}-${to[count]}`);
      if (count >= from.length - 1) {
        clearInterval(timer);
        if (config.resultFen) {
          ChessBoard.board.position(config.resultFen);
        }
        loadNextConfiguration(4000, next, false);
      }
      count++;
    }, 2000)
  }

  const chessConfig = {
    config: {
      position: position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
 * @name lesson18Activity3
 * @function
 * @param { config }
 * @description: show a 5x5 board
 */

export function lesson18Activity3(config) {
  let position = config.position,
    squares = config.squares;

  let afterLoad = function () {
    prepareChessboard(config);
    $(function () {
      $('.row-5277c:nth-child(-n+3)').css('display', 'none');
      $('.row-5277c .square-55d63:nth-last-child(-n+4)').css('display', 'none');
      squares.forEach(element => {
        $(element).css('font-size', '22px').css('color', '#ffe100').css('text-align', 'right');
      });
      $('.square-a5').text(1); $('.square-b4').text(4);
      $('.square-c3').text(9); $('.square-d2').text('?');
      $('.square-e1').text(25);
    })
  }

  const chessConfig = {
    config: {
      position: position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/*
* @name lesson18Activity4
* @function
* @param { config }
* @description: show a 6x6 board
*/

export function lesson18Activity4(config) {
  let position = config.position,
    squares = config.squares;

  let afterLoad = function () {
    prepareChessboard(config);
    $(function () {
      $('.row-5277c:nth-child(-n+2)').css('display', 'none');
      $('.row-5277c .square-55d63:nth-last-child(-n+3)').css('display', 'none');
      squares.forEach(element => {
        $(element).css('font-size', '22px').css('color', '#ffe100');
      });
      $('.square-f6').text(1); $('.square-e5').text(4);
      $('.square-d4').text(9); $('.square-c3').text(16);
      $('.square-b2').text(25); $('.square-a1').text('?');
    })
  }

  const chessConfig = {
    config: {
      position: position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_18/assignments.js